export default class {
  constructor() {
    this.globalNav = document.getElementById('js-globalNav');
    this.navigations = document.querySelectorAll('.menu-item-has-children');
    this.navigationsLink = document.querySelectorAll('.menu-item-has-children.-linkNone > a');
  }

  init() {
    this.navigationsLink.forEach((navigation) => {
      navigation.addEventListener('click', (event) => {
        event.preventDefault();
      });
    });
    this.navigationsLink.forEach((navigation) => {
      const targetNavigation = navigation.nextElementSibling;
      targetNavigation.classList.add('is-loaded');
      navigation.addEventListener('mouseover', (event) => {
        const targetElement = event.currentTarget.nextElementSibling;
        event.currentTarget.classList.add('is-active');
        targetElement.classList.add('is-active');
      });
    });
    this.globalNav.addEventListener('mouseleave', () => {
      this.navigations.forEach((navigation) => {
        const targetNavigation = navigation.querySelector('.sub-menu');
        const nextElement = navigation.nextElementSibling;
        if (nextElement && nextElement.classList.contains('is-active')) {
          navigation.nextElementSibling.classList.remove('is-active');
        }
        targetNavigation.classList.remove('is-active');
      });
    });
    this.globalNav.querySelectorAll('.globalNav__list > .menu-item > a').forEach((item) => {
      item.addEventListener('mouseover', () => {
        if (!item.parentNode.classList.contains('menu-item-has-children')) {
          this.navigations.forEach((navigation) => {
            const targetNavigation = navigation.querySelector('.sub-menu');
            if (navigation.classList.contains('is-active')) {
              navigation.classList.remove('is-active');
            }
            targetNavigation.classList.remove('is-active');
          });
        }
      });
    });
  }
}
